export const SHOP_ADMIN_PAGES_URLS = {
  home: '/',
  'shop-details': '/restaurant',
  'new-shop': '/creation',
  'edit-shop': '/edition',
  'promotion-codes': '/coupons',
  'categories-settings': '/categories',
  'new-product': '/produit/creation',
  'edit-product': '/produit/edition',
  'order-reject': '/commande/refus',
  'order-accept': '/commande/acceptation',
  'order-administration': '/gestion-des-commandes',
  'create-order': '/nouvelle-commande',
  'order-statistics': '/chiffres',
  'best-sellers': '/meilleures-ventes',
  'order-billing': '/facturation',
  users: '/clients',
  'client-details': '/client/details',
  'please-upgrade': '/commandes-premium',
  'api-keys': '/api-key',
  integrations: '/integrations',
  invoices: '/factures',
  'cash-journal': '/journal-de-caisse',
  reservations: '/reservations',
  'reservation-decision': '/reservations/decision',
};
